(function () {
  document.querySelectorAll('.product-gallery__media-list .product-gallery__media-list-item').forEach(mediaItem => {
    const hasAigenImage = Array.from(mediaItem.querySelectorAll('img')).some(img => img.src.includes('_aigen_'));

    if (hasAigenImage) {
      mediaItem.classList.add('aigen-img');

      if (!mediaItem.querySelector('.product-badges__badge.aigen-badge')) {
        const badge = document.createElement('div');
        badge.className = 'aigen-badge';
        badge.textContent = 'Edited by AI';

        const mediaWrapper = mediaItem.querySelector('.product-gallery__media');
        if (mediaWrapper) {
          mediaWrapper.appendChild(badge);
        } else {
          mediaItem.appendChild(badge);
        }
      }
    }
  });
})();

document.querySelectorAll('.retail_price_value').forEach(function(el) {
  const raw = parseFloat(el.dataset.raw);
  if (!isNaN(raw)) {
    el.textContent = raw.toLocaleString('ja-JP', {
      style: 'currency',
      currency: 'JPY'
    });
  }
});

